import { ICON_COLOR } from '@zep-us/zus';
import { useTranslation } from 'next-i18next';
import { AnswerIconO, AnswerIconX } from '@/shared/components/AnswerIcon';
export interface AllowPassBadgeProps {
  /** 통과 허용 여부 */
  isAllowPass: boolean;
}

/**
 * AllowPassBadge - 퀴즈 통과 허용 여부 배지
 *
 * @description
 * 퀴즈에서 통과를 허용하는지 여부를 아이콘과 텍스트로 표시합니다.
 * - 허용: locale-aware 정답 허용 아이콘 + "통과 허용"
 * - 비허용: locale-aware 불가 아이콘 + "통과 불가"
 */
export const AllowPassBadge = ({
  isAllowPass
}: AllowPassBadgeProps) => {
  const {
    t
  } = useTranslation(['common']);
  return <div className="flex shrink-0 items-center gap-2xs" data-sentry-component="AllowPassBadge" data-sentry-source-file="AllowPassBadge.tsx">
      <div className="flex size-[16px] items-center justify-center">
        {isAllowPass ? <AnswerIconO width="16" height="16" color={ICON_COLOR.neutral} /> : <AnswerIconX width="16" height="16" color={ICON_COLOR.neutral} />}
      </div>
      <p className="text-caption-lg-semibold text-neutral">
        {isAllowPass ? t('detail.wrongAnswerAllow') : t('detail.notAllow')}
      </p>
    </div>;
};